import { c as _c } from "react/compiler-runtime";
/* eslint-disable max-len */
import { motion } from 'framer-motion';
function NovaRobotIcon(t0) {
  const $ = _c(6);
  const {
    width: t1,
    className
  } = t0;
  const width = t1 === undefined ? 90 : t1;
  let t2;
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M55.5 15.9595C60.2893 15.9595 64.1719 19.842 64.1719 24.6313C64.1719 28.1869 62.0309 31.2402 58.9688 32.5786V43.0103H68.5078C79.837 43.0103 89.2866 50.7655 91.4541 61.0688C91.6087 61.0586 91.7647 61.0522 91.9219 61.0522C95.7533 61.0523 98.8593 64.1583 98.8594 67.9897V71.4585C98.8594 75.29 95.7533 78.396 91.9219 78.396C91.6499 78.396 91.3819 78.3776 91.1182 78.3472C88.436 87.9626 79.3308 95.0415 68.5078 95.0415H42.4922C31.6692 95.0415 22.5629 87.9627 19.8809 78.3472C19.6174 78.3775 19.3497 78.396 19.0781 78.396C15.2466 78.396 12.1406 75.29 12.1406 71.4585V67.9897C12.1407 64.1583 15.2467 61.0522 19.0781 61.0522C19.235 61.0522 19.3906 61.0586 19.5449 61.0688C21.7124 50.7654 31.1629 43.0103 42.4922 43.0103H52.0312V32.5786C48.9691 31.2402 46.8281 28.1869 46.8281 24.6313C46.8281 19.842 50.7107 15.9595 55.5 15.9595ZM42.4922 53.1851C33.4615 53.1851 29.6348 60.3844 29.6348 65.5776V72.4731C29.6348 77.6664 33.4615 84.8667 42.4922 84.8667H68.5078C78.4388 84.8667 81.3652 77.6664 81.3652 72.4731V65.5776C81.3652 60.3844 76.8878 53.1851 68.5078 53.1851H42.4922Z" fill="#98A6B5" />;
    t3 = <path d="M47 71C47 70.4035 46.8047 69.4642 46.2773 68.7314C45.8231 68.1006 45.0482 67.5 43.5 67.5C41.9518 67.5 41.1769 68.1006 40.7227 68.7314C40.1953 69.4642 40 70.4035 40 71C40 72.1046 39.1046 73 38 73C36.8954 73 36 72.1046 36 71C36 69.7633 36.3542 67.9524 37.4766 66.3936C38.6724 64.7328 40.6482 63.5 43.5 63.5C46.3518 63.5 48.3276 64.7328 49.5234 66.3936C50.6458 67.9524 51 69.7633 51 71C51 72.1046 50.1046 73 49 73C47.8954 73 47 72.1046 47 71Z" fill="#98A6B5" />;
    t4 = <path d="M72 71C72 70.4035 71.8047 69.4642 71.2773 68.7314C70.8231 68.1006 70.0482 67.5 68.5 67.5C66.9518 67.5 66.1769 68.1006 65.7227 68.7314C65.1953 69.4642 65 70.4035 65 71C65 72.1046 64.1046 73 63 73C61.8954 73 61 72.1046 61 71C61 69.7633 61.3542 67.9524 62.4766 66.3936C63.6724 64.7328 65.6482 63.5 68.5 63.5C71.3518 63.5 73.3276 64.7328 74.5234 66.3936C75.6458 67.9524 76 69.7633 76 71C76 72.1046 75.1046 73 74 73C72.8954 73 72 72.1046 72 71Z" fill="#98A6B5" />;
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
  } else {
    t2 = $[0];
    t3 = $[1];
    t4 = $[2];
  }
  let t5;
  if ($[3] !== className || $[4] !== width) {
    t5 = <svg className={className} width={width} height={width} viewBox="0 0 111 111" fill="none" xmlns="http://www.w3.org/2000/svg">{t2}{t3}{t4}</svg>;
    $[3] = className;
    $[4] = width;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
}
function NovaBackgroundBlob(t0) {
  const $ = _c(3);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M43.2835 176.597C15.834 172.513 -4.88098 142.201 1.00574 106.849C5.82238 70.0646 59.8729 17.5147 104.826 7.48244C149.779 -2.5498 251.459 -15.9261 292.666 67.1982C333.873 150.323 286.779 201.917 256.81 201.917C226.842 201.917 221.688 168.986 168.51 160.355C115.529 151.755 85.0253 182.808 43.2835 176.597Z" fill="#F4F8FE" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = <svg className={className} width="309" height="202" viewBox="0 0 309 202" fill="none" xmlns="http://www.w3.org/2000/svg">{t1}</svg>;
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
export function Greeting({
  message,
  icon = <NovaRobotIcon />
}: {
  message?: string;
  icon?: React.ReactNode;
}) {
  return <div key="overview" className="mx-auto flex size-full max-w-3xl flex-col items-center justify-center px-8 text-center">
      {/* Nova art: background blob behind robot + text */}
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      delay: 0.3
    }} className="relative flex flex-col items-center">
        <NovaBackgroundBlob className="absolute top-[30px] w-[280px] rotate-[6deg]" />

        <div className="relative z-10 size-[90px]">{icon}</div>

        <motion.h2 initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.5
      }} className="text-foreground relative z-10 mb-2 text-[17px] leading-6 font-semibold">
          How can I help you today?
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.6
      }} className="text-muted-foreground text-md relative z-10 max-w-[360px] leading-normal">
          {message || "I'm Nova Assist, your AI assistant at Newfront. Ask me insurance questions, upload documents to analyze, or get help with calculations and communications."}
        </motion.p>
      </motion.div>
    </div>;
}